"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WasfatyCancellationReason_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var WasfatyCancellationReason_Factory = /** @class */ (function () {
    function WasfatyCancellationReason_Factory() {
    }
    WasfatyCancellationReason_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            Code: model.Code,
            Description: model.Description,
            Id: model.Id,
        };
        return result;
    };
    WasfatyCancellationReason_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            Code: model.Code,
            Description: model.Description,
            Id: model.Id,
        };
        return result;
    };
    return WasfatyCancellationReason_Factory;
}());
exports.WasfatyCancellationReason_Factory = WasfatyCancellationReason_Factory;
